(function(angular){
	'use strict';

	angular.module('formValidationModule', [
		'BaseConfig',
		'ngMessages',
		'optionsModule'
	]);
})(window.angular);